import { render, staticRenderFns } from "./ShowScreenshotModal.vue?vue&type=template&id=35db58f1&scoped=true&"
import script from "./ShowScreenshotModal.vue?vue&type=script&lang=js&"
export * from "./ShowScreenshotModal.vue?vue&type=script&lang=js&"
import style0 from "./ShowScreenshotModal.vue?vue&type=style&index=0&id=35db58f1&lang=scss&scoped=true&"
import style1 from "./ShowScreenshotModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35db58f1",
  null
  
)

export default component.exports